import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../_services/user.service';

@Injectable()
export class UserManagementGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.hasSinglePermission('UserManagement').pipe(map(
        data => {
            if (data === true) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.router.navigate(['login']);
            return false;
        }));
    }

}

@Injectable()
export class AdministrationGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.hasSinglePermission('SiteManagement').pipe(map(
        data => {
            if (data === true) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.router.navigate(['login']);
            return false;
        }));
    }

}
